const colors = {
    transparent: "rgba(0,0,0,0)",
    dark: "rgba(0, 0, 0, 1)",    
    textHalo:"hsl(0, 0%, 100%)",
    geo_default_stroke: 'rgba(0,91,34,0.7)',
    geo_default_fill: "rgba(139,178,129,0.4)",
    geo_selected_fill: 'rgba(255,255,0,0.4)',
    geo_selected_stroke: "rgba(120,120,120,0.5)",
    geo_highlight_stroke:"rgba(100, 100, 100,1)",
    geo_highlight_fill:"rgba(143, 43, 0, 0.25)"
};
export default colors;